import { FC } from 'react';
import cx from 'classnames/bind';

import { StatusIcon } from '../StatusIcon';

import styles from './Box.module.scss';

interface BoxProps {
  text: string;
  src: string;
  achievement: boolean;
  achievement_without_score: boolean | null;
  setStep: (value: number) => void;
  setIdPack: (value: number) => void;
  idPack: number;
  isAllPointsReceived: boolean;
  lastGameForPoints: boolean;
}

const cn = cx.bind(styles);

const Box: FC<BoxProps> = ({
  text,
  src,
  achievement,
  setStep,
  setIdPack,
  idPack,
  isAllPointsReceived,
  achievement_without_score,
  lastGameForPoints,
}) => {
  const handleClick = () => {
    setStep(4);
    setIdPack(idPack);
  };

  return (
    <button
      type="button"
      className={cn('container')}
      onClick={handleClick}
      disabled={
        isAllPointsReceived
          ? lastGameForPoints
            ? achievement !== null
            : achievement_without_score !== null
          : achievement !== null
      }
    >
      <div className={cn('title-container')}>
        <h2 className={cn('title')}>{text}</h2>

        {isAllPointsReceived
          ? lastGameForPoints
            ? achievement !== null && (
                <StatusIcon isSuccess={achievement} className={cn('status')} />
              )
            : achievement_without_score !== null && (
                <StatusIcon
                  isSuccess={achievement_without_score}
                  className={cn('status')}
                />
              )
          : achievement !== null && (
              <StatusIcon isSuccess={achievement} className={cn('status')} />
            )}
      </div>
      <img className={cn('img')} src={src} alt="Упаковка сигарет" />
    </button>
  );
};

export default Box;
